var map = {
	"./bsd.jpeg": 5808,
	"./ctotalks.jpg": 25321,
	"./devtalk.jpg": 85386,
	"./kwadrans.jpg": 96614,
	"./napodsluchu.jpg": 32264,
	"./nsm.jpg": 65412,
	"./piatkipodeployu.jpg": 32978,
	"./piwnicait.png": 93905,
	"./poit.png": 53225,
	"./poprostujs.jpg": 71360,
	"./przeprogramowani.jpg": 49362,
	"./stacja.jpeg": 16322,
	"./toolsday.jpg": 46416,
	"./zarubieza.jpg": 18510
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50612;